var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Watch, PropertyConverters, P } from '@pacem/pacem-core';
import { UiElement } from './types';
import { TAG_MIDDLE_NAME } from './constants';
//namespace Pacem.Components.Drawing {
let PacemImageElement = class PacemImageElement extends UiElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'src':
                case 'x':
                case 'y':
                case 'width':
                case 'height':
                    this.stage?.draw(this);
                    break;
            }
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemImageElement.prototype, "src", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemImageElement.prototype, "x", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemImageElement.prototype, "y", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemImageElement.prototype, "width", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemImageElement.prototype, "height", void 0);
PacemImageElement = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-image' })
], PacemImageElement);
export { PacemImageElement };
